'use client';

import { hasPlantImage } from '@modules/plants/business_logic';

export interface PlantAvatarWebProps {
  name: string;
  emoji: string;
  imagePath?: string;
  size?: number;
}

export function PlantAvatarWeb({ name, emoji, imagePath, size = 32 }: PlantAvatarWebProps) {
  return (
    <div
      className="flex shrink-0 items-center justify-center"
      style={{ width: size, height: size }}>
      {hasPlantImage(imagePath) ? (
        <img
          src={imagePath!}
          alt={name}
          width={size}
          height={size}
          style={{ width: size, height: size, borderRadius: 4, objectFit: 'contain' }}
        />
      ) : (
        <span style={{ fontSize: size * 0.75, lineHeight: `${size * 0.75}px` }}>{emoji}</span>
      )}
    </div>
  );
}
